import Header from '@/features/pos/components/FoundProductList/parts/Header'
import ProductListComponent from '@/features/pos/components/ProductCatalog/parts/ProductList/Component'
import { useSelectedCategoryProductItems } from '@/features/pos/components/ProductCatalog/parts/ProductList/hooks/useSelectedCategoryProductItems'
import { listStylesheet } from '@/features/pos/components/ProductCatalog/parts/ProductList/styles'
import { Container } from '@/features/pos/components/ProductCatalog/parts/ProductList/types'
import { useFoundProducts } from '@/features/pos/hooks/search-product/useFoundProducts'
import { useScreenLayout } from '@/hooks/screen'
import { FC } from 'react'
import { useStyles } from 'react-native-unistyles'

interface StatefulProductListProps {
    categoryId?: string
    containers?: readonly Container[]
    subcategoryId?: string
    searchProduct: string
}

const ProductList: FC<StatefulProductListProps> = ({
    categoryId,
    containers,
    subcategoryId,
    searchProduct,
}) => {
    const items = useSelectedCategoryProductItems(categoryId, containers)

    const foundItems = useFoundProducts(searchProduct)

    const layout = useScreenLayout()

    const { styles } = useStyles(listStylesheet, { layout })

    return (
        <ProductListComponent
            mode={searchProduct ? 'column' : 'grid'}
            items={searchProduct ? foundItems : items}
            subcategoryId={subcategoryId}
            ListHeaderComponent={searchProduct && foundItems.length ? Header : undefined}
            contentContainerStyle={styles.contentContainer}
        />
    )
}

export default ProductList
